import { uploadImageObj } from '../common-utils-module.js';

// eslint-disable-next-line import/prefer-default-export
export function initFieldUploadImage({ fieldUploadImage, rootPath }) {
  const $form = $(fieldUploadImage);
  const $container = $form.find('.image-upload-field__container');
  const $checkbox = $form.find('.image-upload-field__checkbox');
  const $preview = $form.find('.image-upload-field__preview');
  const $inputSrc = $form.find('.image-upload-field__src-input');
  const $inputSrcHidden = $form.find('.image-upload-field__src-input-hidden');

  return {
    setDefaultSrc,
    initListeners,
  };

  function initListeners() {
    $checkbox.on('click', function () {
      if (this.checked) {
        enabledContainer();
      } else {
        disableContainer();
        setSrc('');
      }
    });
    uploadImageObj({
      fieldUploadImage,
      rootPath,
    });
    $form.find('.image-upload-field__btn-download').on('click', function () {
      const previewSrc = $form.find('.image-upload-field__preview').attr('src');
      if (previewSrc) {
        this.href = previewSrc;
      }
    });
  }

  function enabledContainer() {
    $container.removeClass('disable-cont');
  }

  function disableContainer() {
    $container.addClass('disable-cont');
  }

  function setSrc(src = '') {
    $preview.attr('src', src);
    $inputSrc.val(src);
    $inputSrcHidden.val(src);
  }

  function setDefaultSrc(src = '') {
    if (src) {
      $checkbox.prop('checked', true);
      enabledContainer();
    } else {
      $checkbox.prop('checked', false);
      disableContainer();
    }

    setSrc(src);
  }
}
